import { useEffect, useState } from "react";

const MOBILE_PAGE_COUNT = 3;


function Pagination(props) {

    const [items, setItems] = useState([]);

    useEffect(() => {
        // calculate total pages
        //const totalPages = Math.ceil(props.pages_total / pageSize);
        //debugger;
        let startPage, endPage;
        if (props.pages_total <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = props.pages_total;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (props.page <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (props.page + 4 >= props.pages_total) {
                startPage = props.pages_total - 9;
                endPage = props.pages_total;
            } else {
                startPage = props.page - 5;
                endPage = props.page + 4;
            }
        }

        // create an array of pages to ng-repeat in the pager control
        let pages = [...Array((endPage + 1) - startPage).keys()].map(i => startPage + i);

        // Ten page buttons don't fit a phone, so below md only the current page and its
        // neighbours show (three buttons, clamped to the ends of the range); the rest
        // are hidden with CSS rather than dropped, so desktop is unchanged.
        const mobileCount = Math.min(MOBILE_PAGE_COUNT, pages.length);
        const mobileStart = Math.min(
            Math.max(props.page - Math.floor(mobileCount / 2), startPage),
            endPage - mobileCount + 1
        );
        const mobileEnd = mobileStart + mobileCount - 1;

        let items = [];

        pages.forEach((number) => {
            const mobileVisible = number >= mobileStart && number <= mobileEnd;
            items.push(
                <div key={number}
                    onClick={e => {

                        if (props.onItemClick)
                            props.onItemClick(e.target.innerText);
                    }}
                    className={'disc-6 rounded-2  center-content cursor-pointer m-1 flex-shrink-0 ' + (mobileVisible ? '' : 'd-none d-md-flex ') + (number === props.page ? 'bg-crayola-red-500 text-white' : 'bg-neutral-gray-900 text-white')}>{number}</div>,
            );
        });

        setItems(items);

    }, [props]);


    return (
        <>
            {0 < props.pages_total ?
                <div className="d-flex justify-content-center mw-100">
                    <div className="d-flex align-items-center flex-nowrap mw-100">
                        <div
                            onClick={() => {
                                if (props.onItemClick)
                                    props.onItemClick(props.page - 1);
                            }}
                            aria-label="Previous page"
                            className={'btn btn-link me-md-1 px-2 px-md-3 py-2 border-0 text-nowrap flex-shrink-0 ' + (1 > props.page - 1 ? 'disabled' : '')}>
                            <i className="fa-light fa-angle-left me-md-2"></i><span className="d-none d-md-inline">Previous</span>
                        </div>

                        {0 < props.pages_total &&
                            <>
                                {props.page > 1 && props.pages_total > 1 && <div className="me-1 me-md-2">&middot;&middot;&middot;</div>}
                                {items}
                                {props.page < props.pages_total && props.pages_total > 1 && <div className="ms-1 ms-md-2">&middot;&middot;&middot;</div>}
                            </>
                        }

                        <div
                            onClick={() => {
                                if (props.onItemClick)
                                    props.onItemClick(props.page + 1);
                            }}
                            aria-label="Next page"
                            className={'btn btn-link ms-md-1 px-2 px-md-3 py-2 border-0 text-nowrap flex-shrink-0 ' + (props.pages_total < props.page + 1 ? 'disabled' : '')}>
                            <span className="d-none d-md-inline">Next</span><i className="fa-light fa-angle-right ms-md-2"></i>
                        </div>
                    </div>
                </div>
                :
                <></>
            }
        </>
    )

};


export default Pagination
